import { useState } from 'react';
import { ApiEntity } from '@backstage/catalog-model';
import { TableColumn } from '@backstage/core-components';
import { EntityTable } from '@backstage/plugin-catalog-react';
import IconButton from '@material-ui/core/IconButton';
import CodeIcon from '@material-ui/icons/Code';
import { ApiDefinitionDialog, ApiTypeTitle } from '@backstage/plugin-api-docs';
import {
  createServiceGroupAwareSystemColumn,
  createServiceGroupColumn,
} from '../service-group-columns';

function ApiDefinitionButton({ apiEntity }: { apiEntity: ApiEntity }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <IconButton
        size="small"
        aria-label="View API definition"
        onClick={() => setOpen(true)}
      >
        <CodeIcon fontSize="small" />
      </IconButton>
      <ApiDefinitionDialog
        open={open}
        entity={apiEntity}
        onClose={() => setOpen(false)}
      />
    </>
  );
}

/**
 * The legacy-props column set ProvidedApisCard/ConsumedApisCard would
 * otherwise build themselves via their own internal (unexported)
 * getApiEntityColumns preset - rebuilt here rather than imported because
 * this app's plugin-catalog-react (v1.21.6, hoisted) doesn't match the
 * version plugin-api-docs bundles a private nested copy of (v3.2.0) for its
 * newer columnConfig API. Passing `columns` as a legacy prop forces both
 * cards down their older, stable-API rendering path instead, which is what
 * makes overriding them safe without fighting that version mismatch. Shared
 * between the two since they show the same API columns either way.
 */
export function createApiEntityColumns(): TableColumn<ApiEntity>[] {
  return [
    EntityTable.columns.createEntityRefColumn<ApiEntity>({
      defaultKind: 'API',
    }),
    createServiceGroupAwareSystemColumn<ApiEntity>(),
    createServiceGroupColumn<ApiEntity>(),
    EntityTable.columns.createOwnerColumn<ApiEntity>(),
    {
      title: 'Type',
      field: 'spec.type',
      render: entity => <ApiTypeTitle apiEntity={entity} />,
    },
    EntityTable.columns.createSpecLifecycleColumn<ApiEntity>(),
    EntityTable.columns.createMetadataDescriptionColumn<ApiEntity>(),
    {
      title: 'API Definition',
      render: entity => <ApiDefinitionButton apiEntity={entity} />,
    },
  ];
}
